import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import { PostView } from '@/components/PostView';
import { ProfileView } from '@/components/ProfileView';
import NotFound from './NotFound';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  switch (decoded.type) {
    case 'npub':
      return <ProfileView pubkey={decoded.data} />;

    case 'nprofile':
      return <ProfileView pubkey={decoded.data.pubkey} />;

    case 'note':
      return <PostView id={decoded.data} />;

    case 'nevent':
      return <PostView id={decoded.data.id} author={decoded.data.author} />;

    default:
      // naddr, nsec, nrelay, unknown → 404
      return <NotFound />;
  }
}
